<template>
	<IntersectionChild
		:class="{
			'retrieving-messages': true,
			loading: isLoadingMore,
		}"
		@click="$emit('click', $event)"
		@enter="$emit('enter', $event)"
		@leave="$emit('leave', $event)"
	>
		{{ $t('chat_retrieving_messages') }}
	</IntersectionChild>
</template>

<script>
import { IntersectionChild } from '@/components/common/Intersection'

export default {
	name: 'MessageListLoader',
	components: { IntersectionChild },
	props: { isLoadingMore: { type: Boolean, default: null } },
	emits: ['click', 'enter', 'leave']
}
</script>

<style lang="scss" scoped></style>
